import axios from "axios";
import { token } from "@/services/token";

const getBaseUrl = () => {
  return process.env.VUE_APP_API_URL;
};

export const createHttpClient = ({
  basePath = "/v3",
  headers = { "Content-Type": "application/vnd.api+json" },
  useAuth = true,
  staticToken = null
} = {}) => {
  const instance = axios.create({
    baseURL: `${getBaseUrl()}${basePath}`,
    headers
  });

  // instance.interceptors.request.use(config => {
  //   if (staticToken) {
  //     config.headers.Authorization = `Bearer ${staticToken}`;
  //   } else if (useAuth && token.accessToken) {
  //     config.headers.Authorization = `${token.accessTokenType} ${token.accessToken}`;
  //   }
  //   return config;
  // });

  const getAndroidToken = () => {
    if (!window.Android) {
      return null;
    }
    const token = window.Android.getAccessToken();
    return token;
  };

  instance.interceptors.request.use((config) => {
    if (staticToken) {
      config.headers.Authorization = `Bearer ${staticToken}`;
      return config;
    }

    if (useAuth && token.accessToken) {
      config.headers.Authorization =
        `${token.accessTokenType} ${token.accessToken}`;
      return config;
    }

    const androidToken = getAndroidToken();

    // console.log("androidToken =", androidToken);
    if (androidToken) {
      config.headers.Authorization = `Bearer ${androidToken}`;
    }

    return config;
  });

  return instance;
};
